/* ══════════════════════════════════════════════════════════════════════
   Sport Energy — Vejledning (forside-sektion) · FASE 1.2.0 · 3. juli 2026

   Roterer og tegner læringskortene fra window.SEVejledning (sat i sektionen).
   1 kort / 2 lige / feature+2 (trio) / feature+3 i række (quad). Rotation:
     week  — deterministisk efter ISO-ugenummer (roligt, forudsigeligt)
     visit — nyt udsnit ved hvert sidebesøg (mest variation)
     none  — nyeste øverst, ingen rotation
   Feature er altid en blog-artikel når muligt (nyhedsbrevet er ugens ophæng);
   guides fylder kompakt-pladserne. Ingen live-kald til Windsor — data er
   allerede i sektionen. Ingen regex-literaler, indexOf hvor nødvendigt.
   ══════════════════════════════════════════════════════════════════════ */
(function () {
  "use strict";

  var CFG = window.SEVejledning;
  if (!CFG || !Array.isArray(CFG.posts)) { return; }

  var root = document.getElementById("vl-root");
  var grid = document.getElementById("vl-grid");
  var empty = document.getElementById("vl-empty");
  if (!root || !grid) { return; }

  var posts = CFG.posts.slice();

  // Tom blog + ingen tændte guides → tom-tilstand, skjul grid
  if (posts.length === 0) {
    grid.setAttribute("hidden", "");
    if (empty) { empty.removeAttribute("hidden"); }
    return;
  }

  /* ─── ISO-ugenummer (samme frø som resten af platformen) ───────────── */
  function isoWeek(d) {
    var date = new Date(Date.UTC(d.getFullYear(), d.getMonth(), d.getDate()));
    var day = date.getUTCDay() || 7;
    date.setUTCDate(date.getUTCDate() + 4 - day);
    var yearStart = new Date(Date.UTC(date.getUTCFullYear(), 0, 1));
    return Math.ceil((((date - yearStart) / 86400000) + 1) / 7);
  }

  /* ─── Vælg de synlige (1 feature + 2 kompakte) ─────────────────────── */
  function pick() {
    var pool = posts.slice();
    var mode = CFG.rotation || "week";
    var offset = 0;

    if (mode === "week") {
      offset = isoWeek(new Date()) % pool.length;
    } else if (mode === "visit") {
      offset = Math.floor(Math.random() * pool.length);
    } // none → offset 0 (nyeste øverst, data er allerede nyeste-først)

    var rotated = pool.slice(offset).concat(pool.slice(0, offset));

    // Feature skal helst være en blog-artikel; ellers første post
    var feat = null, i;
    for (i = 0; i < rotated.length; i++) {
      if (rotated[i].type === "blog") { feat = rotated[i]; break; }
    }
    if (!feat) { feat = rotated[0]; }

    // Øvrige kort: 3 kompakte ved 4+ indlæg (quad), ellers 2 (trio)
    var restMax = pool.length >= 4 ? 3 : 2;
    var rest = [];
    for (i = 0; i < rotated.length && rest.length < restMax; i++) {
      if (rotated[i] !== feat) { rest.push(rotated[i]); }
    }

    // Antal styrer layoutet, så sektionen ser hel ud fra første artikel:
    //   1 post   → ét roligt fuldbredde-kort
    //   2 poste  → to lige kort side om side
    //   3 poste  → feature + to kompakte i højre kolonne
    //   4+ poste → feature i fuld bredde + tre kompakte i række under (quad)
    var visible = rotated.slice(0, 3);
    return { feat: feat, rest: rest, visible: visible, count: rotated.length };
  }

  /* ─── SVG-fragmenter ───────────────────────────────────────────────── */
  var ICON_ARROW = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" aria-hidden="true"><path d="M5 12h14M13 6l6 6-6 6" stroke-linecap="round" stroke-linejoin="round"/></svg>';
  var ICON_MARK = '<svg viewBox="0 0 24 24" fill="none" stroke="#1fd4b4" stroke-width="1.4" aria-hidden="true"><path d="M4 5h16M4 12h16M4 19h10" stroke-linecap="round"/></svg>';

  function badge(type) {
    if (type === "guide") {
      return '<span class="vl-badge vl-badge--guide">'
        + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 5h16M4 12h16M4 19h10" stroke-linecap="round"/></svg>'
        + 'Guide</span>';
    }
    return '<span class="vl-badge">'
      + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" aria-hidden="true"><path d="M4 4h16v16H4z"/><path d="M8 9h8M8 13h5" stroke-linecap="round"/></svg>'
      + 'Nyhedsbrev</span>';
  }

  function media(item) {
    var inner;
    if (item.image) {
      inner = '<img src="' + esc(item.image) + '" alt="" loading="lazy" decoding="async">';
    } else {
      inner = ICON_MARK;
    }
    var cls = item.image ? "vl-media" : "vl-media vl-media--noimg";
    return '<div class="' + cls + '">' + badge(item.type) + inner
      + '<div class="vl-media__overlay"></div></div>';
  }

  function kicker(item) {
    if (item.type === "guide") { return "Guide"; }
    return item.tag ? item.tag : "Nyhedsbrev";
  }

  function foot(item) {
    return '<div class="vl-foot">'
      + '<span>' + esc(item.date) + '</span>'
      + '<span class="vl-read">Læs' + ICON_ARROW + '</span>'
      + '</div>';
  }

  function card(item, variant) {
    var cls = "vl-card vl-card--" + variant;
    return '<a class="' + cls + '" href="' + esc(item.url) + '">'
      + media(item)
      + '<div class="vl-body">'
      + '<div class="vl-kicker">' + esc(kicker(item)) + '</div>'
      + '<div class="vl-h">' + esc(item.title) + '</div>'
      + '<div class="vl-excerpt">' + esc(item.excerpt) + '</div>'
      + foot(item)
      + '</div></a>';
  }

  function esc(s) {
    if (s == null) { return ""; }
    return String(s)
      .split("&").join("&amp;")
      .split("<").join("&lt;")
      .split(">").join("&gt;")
      .split('"').join("&quot;");
  }

  /* ─── Tegn ─────────────────────────────────────────────────────────── */
  function render() {
    var sel = pick();
    var html, layout;

    if (sel.count === 1) {
      // Én artikel: ét roligt fuldbredde-kort (ingen tom kolonne)
      layout = "vl-grid--single";
      html = card(sel.feat, "feature");
    } else if (sel.count === 2) {
      // To artikler: to lige kort side om side
      layout = "vl-grid--pair";
      html = sel.visible.map(function (x) { return card(x, "feature"); }).join("");
    } else if (sel.count >= 4) {
      // Fire eller flere: feature i fuld bredde + tre kompakte i række under
      layout = "vl-grid--quad";
      html = card(sel.feat, "feature")
        + '<div class="vl-row-bottom">'
        + sel.rest.map(function (x) { return card(x, "compact"); }).join("")
        + '</div>';
    } else {
      // Tre: feature + to kompakte i højre kolonne
      layout = "vl-grid--trio";
      html = card(sel.feat, "feature")
        + '<div class="vl-col-right">'
        + sel.rest.map(function (x) { return card(x, "compact"); }).join("")
        + '</div>';
    }

    grid.className = "vl-grid " + layout;
    grid.innerHTML = html;

    // Entré (ambient) — respekterer prefers-reduced-motion via CSS
    root.classList.remove("vl-anim");
    void root.offsetWidth;
    root.classList.add("vl-anim");
  }

  render();
})();